import Vue from 'vue'

const getters = {

}
export default getters



//////////////////
// WEBPACK FOOTER
// ./state/error/error.getters.js
// module id = null
// module chunks = 